import React from "react";

const CalendarWeek = () => (
  <div className="grid grid-cols-7 text-center font-semibold">
    {[
      { full: "Domingo", short: "Dom" },
      { full: "Lunes", short: "Lun" },
      { full: "Martes", short: "Mar" },
      { full: "Miércoles", short: "Mié" },
      { full: "Jueves", short: "Jue" },
      { full: "Viernes", short: "Vie" },
      { full: "Sábado", short: "Sáb" },
    ].map((day) => (
      <div key={day.full} className="p-2">
        <span className="block xl:hidden">{day.short}</span> {/* Abreviatura en pantallas pequeñas */}
        <span className="hidden xl:block">{day.full}</span>  {/* Nombre completo en pantallas más grandes */}
      </div>
    ))}
  </div>
);

export default CalendarWeek;
